import React from "react";
import {
  RevenueIcon, ExpensesIcon, CutCostIcon, CustomersIcon,
  EquipmentIcon, SuppliesIcon, ProgressIcon, HistoryIcon, EmpIcon, ClockIcon, SettingsIcon, ProductsIcon,
} from "../icons";

// Tokens — match storefront / styles.js
const ink = "#0A0A0F";
const paper = "#F4F2EC";
const white = "#FFFFFF";
const accent = "#0033FF";
const muted = "rgba(10,10,15,0.58)";
const danger = "#ef4444";
const fontBody = "'Archivo', system-ui, sans-serif";
const fontDisplay = "'Archivo Black', 'Archivo', sans-serif";
const fontMono = "'JetBrains Mono', monospace";

const STORES = [
  { key: "nycmfg", label: "NYC MFG HQ" },
  { key: "designshop", label: "Design Shop" },
  { key: "vibratovault", label: "Vibrato Vault" },
];

const HQ_NAV = [
  { key: "etsylabelbot", label: "Etsy Label Bot", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16v16H4z" /><path d="M9 9h6v6H9z" /><path d="M9 1v3" /><path d="M15 1v3" /><path d="M9 20v3" /><path d="M15 20v3" /><path d="M20 9h3" /><path d="M20 14h3" /><path d="M1 9h3" /><path d="M1 14h3" />
    </svg>
  ) },
  { key: "revenue", label: "Revenue", Icon: RevenueIcon },
  { key: "expenses", label: "Expenses", Icon: ExpensesIcon },
  { key: "cutcost", label: "Job Cost Calculator", Icon: CutCostIcon },
  { key: "progress", label: "Open Jobs", Icon: ProgressIcon },
  { key: "history", label: "Job History", Icon: HistoryIcon },
  { key: "customers", label: "Customers", Icon: CustomersIcon },
  { key: "employees", label: "Employees", Icon: EmpIcon },
  { key: "timeclock", label: "Time Clock", Icon: ClockIcon },
  { key: "equipment", label: "Equipment & Maintenance", Icon: EquipmentIcon },
  { key: "supplies", label: "Materials & Supplies", Icon: SuppliesIcon },
  { key: "instantquoting", label: "Instant Quoting", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M8 6h8" /><path d="M8 10h8" /><path d="M8 14h4" /><path d="M16 18l-2-2 2-2" /><path d="M14 16h4" />
    </svg>
  ) },
  { key: "tour-requests", label: "Tour Requests", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ) },
  { key: "product-dev", label: "Product Development", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3h7v7H3z" /><path d="M14 3h7v4h-7z" /><path d="M14 11h7v10h-7z" /><path d="M3 14h7v7H3z" />
    </svg>
  ) },
  { key: "qrgenerator", label: "QR Generator", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7V5a2 2 0 012-2h2" /><path d="M17 3h2a2 2 0 012 2v2" /><path d="M21 17v2a2 2 0 01-2 2h-2" /><path d="M7 21H5a2 2 0 01-2-2v-2" />
      <rect x="7" y="7" width="10" height="10" rx="1" />
    </svg>
  ) },
  { key: "pdfcombiner", label: "PDF Combiner", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="12" y1="18" x2="12" y2="12" /><line x1="9" y1="15" x2="12" y2="12" /><line x1="15" y1="15" x2="12" y2="12" />
    </svg>
  ) },
];

const DashboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
  </svg>
);

const STORE_NAV = [
  { key: "store-dashboard", label: "Dashboard", Icon: DashboardIcon },
  { key: "store-revenue", label: "Revenue", Icon: RevenueIcon },
  { key: "store-trends", label: "Trends", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ) },
  { key: "store-expenses", label: "Expenses", Icon: ExpensesIcon },
  { key: "store-financing", label: "Financing", dsOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /><path d="M5 15h4" /><path d="M13 15h2" />
    </svg>
  ) },
  { key: "store-products", label: "Products", Icon: ProductsIcon },
  { key: "store-inventory", label: "Inventory", Icon: SuppliesIcon },
  { key: "store-support", label: "Support Tickets", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
  ) },
  { key: "store-requests", label: "Requests", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" />
    </svg>
  ) },
  { key: "store-supplies", label: "Hardware & Supplies", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
    </svg>
  ) },
  { key: "store-filament", label: "Filament Usage", vvOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4" /><path d="M21 12h-2" /><path d="M12 21v-2" />
    </svg>
  ) },
  { key: "store-reverb", label: "Reverb", vvOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 1000 1000" fill="currentColor">
      <path d="M507.95,970.74c-136.33,2.3-266.18-54.28-357.28-154.69C-14.33,634.19-11.54,355.55,157.17,176.95,242.62,86.48,360.3,33.4,484.81,29.44c267.81-8.53,488.8,207.4,486.42,474.82-2.27,254.9-207.72,462.16-463.28,466.48ZM475.19,526.29c2.55-10.33,12.96-15.18,22.51-13.06,8.92,1.98,16.24,7.38,21.79,14.6,21.65,28.18,26.47,62.48,24.6,97.36-3.24,60.61,7.61,150,82.83,159.55,56.17,7.13,113.54-23.81,158.93-53.79,5.81-3.84,16.5-14.9,12.22-21.72-3.25-5.18-13.36-2.87-16.84-.78-15.58,9.35-32.36,12.23-50.34,13.27-16.71.97-31.56-3.28-44.41-14.35-31.67-27.3-48.8-76.54-60.12-115.93-7.01-24.4-19.37-45.6-37.82-62.76-4.28-3.98-12.41-11.63-10.26-17.18.56-1.44,2.89-3.87,4.53-4.57l38.01-16.05c38.77-16.37,78.3-40.47,105.37-73.1,28.23-34.01,39.88-77.9,31.41-121.37-14.7-75.47-103.52-91.95-168.23-93.96-62.03-1.92-123.51,3.39-184.5,15.29-52.74,10.29-108.46,27.87-154.44,55.49-57.96,34.82-97.31,85.91-102.29,155.06-1,13.89-.53,26.7,3.16,39.91,9.92,35.43,41.31,51.48,76.66,52.47,46.55,1.31,98.34-27.29,109.53-74.22-25.96,8.17-55.57,5.72-66.2-23.97-15.73-43.98,6.72-88.38,38.06-119.66,43.97-43.89,111.07-75.73,174.68-74.42-14.68,22.53-28.5,44.09-38.22,68.67-15.9,40.19-96.5,318.3-109.89,370.75l-21.54,84.37c-2.53,9.9-3.15,19.82-2.12,29.54.54,5.08,3.75,8.09,8.58,8.15l31.01.39c15.69.2,57.69,1.78,68.95-9.47,4.92-49.8,13.64-98.34,26.48-146.79l19.06-71.92,8.84-35.76Z"/>
      <path d="M496.55,490.33c-7.28-.47-11.82-6.69-11.67-13.13.11-4.87.63-9.66,2.21-14.47l42.26-128.45c10.15-30.85,22.3-60.04,35.28-89.58,3.72-8.46,8.77-14.35,16.53-19.19,4.38-2.73,9.07-4.97,14.77-3.31,39.91,11.6,66.15,48.56,63.43,90.36-1.45,22.26-5.65,43.44-12.22,64.7-5.34,17.29-12.53,32.83-22.15,47.95-27.75,43.61-76.12,68.5-128.43,65.12Z"/>
    </svg>
  ) },
  { key: "store-etsy", label: "Etsy", Icon: () => (
    <svg width="20" height="20" viewBox="0 0 800 800" fill="currentColor">
      <path d="M400,0C179.09,0,0,179.09,0,400s179.09,400,400,400,400-179.09,400-400S620.91,0,400,0ZM594.84,525.76c-3.63,30.01-7.39,59.99-10.76,90.03-1.24,11.18-.82,11.11-12.28,10.98-87.48-1.09-174.96-2.51-262.45-3-31.35-.18-62.7,1.89-94.06,2.87-4.15.14-8.29.03-13.23.03v-26.95c11.18-2.21,23.03-4.4,34.81-6.94,4.84-1.04,9.65-2.56,14.23-4.4,6.92-2.79,11.27-7.94,12.27-15.53.46-3.57,1.17-7.15,1.2-10.73.6-65.28,1.42-130.54,1.51-195.81.06-40.55-.98-81.09-1.64-121.62-.37-22.95-6.45-30.09-28.83-34.37-9.51-1.81-19.12-3.24-28.53-5.44-2.27-.54-5.5-3.3-5.68-5.29-.68-7.39-.27-14.87-.27-22.95,125.49,2.09,250.26,7.37,376.21-3.5-2.64,42.6-5.28,85.27-7.97,128.71-7.63,0-14.61.61-21.39-.32-2.4-.34-5.4-4.05-6.23-6.79-3.84-12.71-6.68-25.73-10.53-38.45-2.26-7.39-5.3-14.63-8.78-21.53-7.88-15.63-19.7-24.02-38.43-23.7-45.01.79-90.02.24-135.03.27-11.45.01-11.79.39-11.8,11.6-.07,50.57-.1,101.14-.14,151.7-.01,2.76,0,5.52,0,8.99,19.9,0,38.71.31,57.52-.12,12.18-.27,24.35-1.47,36.51-2.47,16.64-1.38,22.55-6.23,26.73-22.29,3.13-12.05,5.94-24.18,8.65-36.33,1.07-4.79,3.25-7,8.5-6.62,6.62.47,13.29.12,20.88.12,0,4.42.04,8.38,0,12.36-.4,47.45-.92,94.9-1.07,142.36-.03,6.31-1.49,8.82-8.26,8.86-19.94.14-19.92.41-24.62-19.06-1.7-7-3.4-14.01-5.24-20.96-4.22-16.02-16.18-21.92-31.22-22.42-28.29-.95-56.62-1.23-84.94-1.77-.77-.01-1.55.41-3.07.82-.14,3.14-.41,6.39-.42,9.63-.07,42.24-.1,84.46-.12,126.69-.02,26.24,9.87,38.97,36.19,39.72,40.49,1.16,81.08.32,121.58-.92,24.5-.74,41.28-15.09,51.79-36.42,8.56-17.4,16.39-35.19,23.63-53.16,3.2-7.97,7.37-11.66,16-10.34,3.74.59,7.66.1,12.92.1-1.48,12.15-2.83,23.24-4.17,34.34Z"/>
    </svg>
  ) },
  { key: "store-amazon", label: "Amazon", dsOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 35.418 35.418" fill="currentColor">
      <path d="M20.948,9.891c-0.857,0.068-1.847,0.136-2.837,0.269c-1.516,0.195-3.032,0.461-4.284,1.053c-2.439,0.994-4.088,3.105-4.088,6.209c0,3.898,2.506,5.875,5.669,5.875c1.057,0,1.913-0.129,2.703-0.328c1.255-0.396,2.31-1.123,3.562-2.441c0.727,0.99,0.923,1.453,2.177,2.509c0.329,0.133,0.658,0.133,0.922-0.066c0.791-0.659,2.174-1.848,2.901-2.508c0.328-0.267,0.263-0.66,0.066-0.992c-0.727-0.924-1.45-1.718-1.45-3.498v-5.943c0-2.513,0.195-4.822-1.647-6.537c-1.518-1.391-3.891-1.916-5.735-1.916c-0.264,0-0.527,0-0.792,0c-3.362,0.197-6.921,1.647-7.714,5.811c-0.13,0.525,0.267,0.726,0.53,0.793l3.691,0.464c0.396-0.07,0.593-0.398,0.658-0.73c0.333-1.449,1.518-2.176,2.836-2.309c0.067,0,0.133,0,0.265,0c0.79,0,1.646,0.332,2.109,0.987c0.523,0.795,0.461,1.853,0.461,2.775L20.948,9.891z M20.223,17.749c-0.461,0.925-1.253,1.519-2.11,1.718c-0.131,0-0.327,0.068-0.526,0.068c-1.45,0-2.31-1.123-2.31-2.775c0-2.11,1.254-3.104,2.836-3.565c0.857-0.197,1.847-0.265,2.836-0.265v0.793C20.948,15.243,21.01,16.43,20.223,17.749z M35.418,26.918v0.215c-0.035,1.291-0.716,3.768-2.328,5.131c-0.322,0.25-0.645,0.107-0.503-0.254c0.469-1.145,1.541-3.803,1.04-4.412c-0.355-0.465-1.826-0.43-3.079-0.322c-0.572,0.072-1.075,0.105-1.469,0.183c-0.357,0.033-0.431-0.287-0.071-0.537c0.466-0.323,0.969-0.573,1.541-0.756c2.039-0.608,4.406-0.25,4.729,0.146C35.348,26.414,35.418,26.629,35.418,26.918z M32.016,29.428c-0.466,0.357-0.965,0.682-1.468,0.973c-3.761,2.261-8.631,3.441-12.856,3.441c-6.807,0-12.895-2.512-17.514-6.709c-0.396-0.324-0.073-0.789,0.393-0.539C5.549,29.5,11.709,31.26,18.084,31.26c4.013,0,8.342-0.754,12.463-2.371c0.285-0.104,0.608-0.252,0.895-0.356C32.087,28.242,32.661,28.965,32.016,29.428z"/>
    </svg>
  ) },
  { key: "store-tiktok", label: "TikTok Shop", dsOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
    </svg>
  ) },
  { key: "store-shopify", label: "Shopify", dsOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M15.337 23.979l7.216-1.561s-2.604-17.613-2.625-17.73c-.018-.116-.114-.192-.211-.192s-1.929-.136-1.929-.136-1.275-1.274-1.439-1.411c-.045-.037-.075-.057-.121-.074l-.914 21.104h.023zM11.71 11.305s-.81-.424-1.774-.424c-1.447 0-1.504.906-1.504 1.141 0 1.232 3.24 1.715 3.24 4.629 0 2.295-1.44 3.76-3.406 3.76-2.354 0-3.54-1.465-3.54-1.465l.646-2.086s1.245 1.066 2.28 1.066c.675 0 .975-.545.975-.932 0-1.619-2.654-1.694-2.654-4.359-.034-2.237 1.571-4.416 4.827-4.416 1.257 0 1.875.361 1.875.361l-.945 2.715-.02.01zM11.17.83c.136 0 .271.038.405.135-.984.465-2.064 1.639-2.508 3.992-.656.213-1.293.405-1.889.578C7.697 3.75 8.951.84 11.17.84V.83zm1.235 2.949v.135c-.754.232-1.583.484-2.394.736.466-1.777 1.333-2.645 2.085-2.971.193.501.309 1.176.309 2.1zm.539-2.234c.694.074 1.141.867 1.429 1.755-.349.114-.735.231-1.158.366v-.252c0-.752-.096-1.371-.271-1.871v.002zm2.992 1.289c-.02 0-.06.021-.078.021s-.289.075-.714.21c-.423-1.233-1.176-2.37-2.508-2.37h-.115C12.135.209 11.669 0 11.265 0 8.159 0 6.675 3.877 6.21 5.846c-1.194.365-2.063.636-2.16.674-.675.213-.694.232-.772.87-.075.462-1.83 14.063-1.83 14.063L15.009 24l.927-21.166z"/>
    </svg>
  ) },
  { key: "store-ebay", label: "eBay", vvOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ) },
  { key: "store-listing-migrator", label: "Listing Migrator", vvOnly: true, Icon: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7h12" /><path d="M4 7l4-4" /><path d="M4 7l4 4" />
      <path d="M20 17H8" /><path d="M20 17l-4-4" /><path d="M20 17l-4 4" />
    </svg>
  ) },
];

const HamburgerIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);
const ChevronLeftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const CloseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const STORE_PREFIXES = { designshop: "ds", vibratovault: "vv" };
const STORE_ABBREV = { nycmfg: "HQ", designshop: "DS", vibratovault: "VV" };

function StoreSelector({ store, setStore, userPermissions }) {
  const visibleStores = STORES.filter((s) => {
    if (s.key === "nycmfg") return true;
    if (!userPermissions) return true;
    const prefix = STORE_PREFIXES[s.key];
    return userPermissions.some((p) => (prefix && p.startsWith(`${prefix}-`)) || p.startsWith("store-"));
  });

  return (
    <div style={{ padding: "14px 16px", borderBottom: `2px solid ${ink}` }}>
      <label style={{
        fontSize: 11, fontWeight: 700, textTransform: "uppercase",
        letterSpacing: "0.1em", color: muted, marginBottom: 8, display: "block",
        fontFamily: fontMono,
      }}>
        Location
      </label>
      <select
        value={store}
        onChange={(e) => setStore(e.target.value)}
        style={{
          width: "100%", padding: "10px 12px", borderRadius: 0,
          border: `2px solid ${ink}`, background: white, color: ink,
          fontSize: 13, fontWeight: 700, fontFamily: fontBody,
          textTransform: "uppercase", letterSpacing: "0.04em",
          outline: "none", cursor: "pointer",
        }}
      >
        {visibleStores.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
      </select>
    </div>
  );
}

function NavList({ section, onNav, store, setStore, userPermissions, badges, collapsed, onToggleCollapse }) {
  const allItems = store === "nycmfg" ? HQ_NAV : STORE_NAV.filter((item) => (!item.vvOnly || store === "vibratovault") && (!item.dsOnly || store === "designshop"));
  const storePrefix = STORE_PREFIXES[store];
  const navItems = userPermissions
    ? allItems.filter((item) => {
        if (store === "nycmfg") return userPermissions.includes(item.key);
        const storeKey = storePrefix ? `${storePrefix}-${item.key.replace("store-", "")}` : item.key;
        return userPermissions.includes(storeKey) || userPermissions.includes(item.key);
      })
    : allItems;

  return (
    <>
      {collapsed ? (
        <div style={{ padding: "16px 0 12px", borderBottom: `2px solid ${ink}`, textAlign: "center" }}>
          <h1 style={{
            fontFamily: fontDisplay, fontSize: 14, fontWeight: 900,
            lineHeight: 1, letterSpacing: "-0.02em", textTransform: "uppercase",
            color: ink, margin: 0,
          }}>
            NYC
          </h1>
        </div>
      ) : (
        <div style={{ padding: "20px 20px 16px", borderBottom: `2px solid ${ink}` }}>
          <h1 style={{
            fontFamily: fontDisplay, fontSize: 24, fontWeight: 900,
            lineHeight: 1, letterSpacing: "-0.02em", textTransform: "uppercase",
            color: ink, margin: 0,
          }}>
            NYC<br />Manufacturing
          </h1>
          <p style={{
            fontFamily: fontMono, fontSize: 10, color: muted,
            marginTop: 6, letterSpacing: "0.1em", textTransform: "uppercase",
          }}>
            ◆ Management Platform
          </p>
        </div>
      )}

      {collapsed ? (
        <div style={{ padding: "10px 8px", borderBottom: `2px solid ${ink}`, display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => onToggleCollapse && onToggleCollapse()}
            title="Location — expand sidebar to switch"
            style={{
              width: "100%", padding: "8px 0", borderRadius: 0,
              border: `2px solid ${ink}`, background: white, color: ink,
              fontSize: 12, fontWeight: 700, fontFamily: fontMono,
              textTransform: "uppercase", letterSpacing: "0.04em",
              cursor: "pointer",
            }}
          >
            {STORE_ABBREV[store] || "HQ"}
          </button>
        </div>
      ) : (
        <StoreSelector store={store} setStore={setStore} userPermissions={userPermissions} />
      )}

      <nav className="no-scrollbar" style={{ padding: collapsed ? "12px 6px" : "12px 10px", display: "flex", flexDirection: "column", gap: 2, flex: 1, overflowY: "auto", minHeight: 0 }}>
        {navItems.map(({ key, label, Icon }) => {
          const active = section === key;
          const badgeCount = badges && badges[key] ? badges[key] : 0;
          return (
            <React.Fragment key={key}>
              {store === "nycmfg" && (key === "customers" || key === "equipment") && (
                <div style={{ height: 2, flexShrink: 0, background: ink, margin: "8px 4px", opacity: 0.4 }} />
              )}
              <button
                onClick={() => onNav(key)}
                title={collapsed ? label : undefined}
                style={{
                  display: "flex", alignItems: "center",
                  gap: collapsed ? 0 : 12,
                  justifyContent: collapsed ? "center" : "flex-start",
                  padding: collapsed ? "10px 0" : "10px 14px",
                  borderRadius: 0,
                  border: "none",
                  width: "100%", textAlign: "left",
                  background: active ? accent : "transparent",
                  color: active ? white : ink,
                  fontSize: 13, fontWeight: 600, cursor: "pointer",
                  fontFamily: fontBody, transition: "all .15s",
                  textTransform: "uppercase", letterSpacing: "0.04em",
                }}
                onMouseEnter={(e) => {
                  if (!active) e.currentTarget.style.background = "rgba(0,51,255,0.08)";
                }}
                onMouseLeave={(e) => {
                  if (!active) e.currentTarget.style.background = "transparent";
                }}
              >
                {collapsed ? (
                  <span style={{ position: "relative", display: "inline-flex" }}>
                    <Icon />
                    {badgeCount > 0 && (
                      <span
                        style={{
                          position: "absolute", top: -5, right: -8,
                          minWidth: 14, height: 14, padding: "0 3px",
                          display: "inline-flex", alignItems: "center", justifyContent: "center",
                          background: active ? white : accent,
                          color: active ? accent : white,
                          fontFamily: fontMono, fontSize: 9, fontWeight: 700,
                          borderRadius: 0,
                        }}
                      >
                        {badgeCount > 9 ? "9+" : badgeCount}
                      </span>
                    )}
                  </span>
                ) : (
                  <>
                    <Icon />
                    <span style={{ flex: 1 }}>{label}</span>
                    {badgeCount > 0 && (
                      <span
                        style={{
                          minWidth: 20,
                          height: 20,
                          padding: "0 6px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: active ? white : accent,
                          color: active ? accent : white,
                          fontFamily: fontMono,
                          fontSize: 11,
                          fontWeight: 700,
                          letterSpacing: "0.02em",
                          borderRadius: 0,
                        }}
                      >
                        {badgeCount > 99 ? "99+" : badgeCount}
                      </span>
                    )}
                  </>
                )}
              </button>
            </React.Fragment>
          );
        })}
      </nav>

      {onToggleCollapse && (
        <div style={{ borderTop: `2px solid ${ink}` }}>
          <button
            onClick={onToggleCollapse}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "100%", padding: "8px 0",
              borderRadius: 0, border: "none",
              background: "transparent", color: ink,
              cursor: "pointer", transition: "all .15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(0,51,255,0.08)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
          >
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </button>
        </div>
      )}

      <div style={{ padding: collapsed ? "6px 6px" : "6px 10px", borderTop: `2px solid ${ink}` }}>
        {(!userPermissions || userPermissions.includes("settings")) && (
          <button
            onClick={() => onNav("settings")}
            title={collapsed ? "Settings" : undefined}
            style={{
              display: "flex", alignItems: "center",
              gap: collapsed ? 0 : 12,
              justifyContent: collapsed ? "center" : "flex-start",
              padding: collapsed ? "7px 0" : "7px 14px",
              borderRadius: 0, border: "none", width: "100%", textAlign: "left",
              background: section === "settings" ? accent : "transparent",
              color: section === "settings" ? white : ink,
              fontSize: 13, fontWeight: 600, cursor: "pointer",
              fontFamily: fontBody, transition: "all .15s",
              textTransform: "uppercase", letterSpacing: "0.04em",
            }}
          >
            <SettingsIcon /> {!collapsed && "Settings"}
          </button>
        )}
        <button
          onClick={() => { sessionStorage.removeItem("nycmfg-auth"); sessionStorage.removeItem("nycmfg-user"); window.location.href = "/"; }}
          title={collapsed ? "Sign Out" : undefined}
          style={{
            display: "flex", alignItems: "center",
            gap: collapsed ? 0 : 12,
            justifyContent: collapsed ? "center" : "flex-start",
            padding: collapsed ? "7px 0" : "7px 14px",
            borderRadius: 0, border: "none", width: "100%", textAlign: "left",
            background: "transparent", color: danger,
            fontSize: 13, fontWeight: 600, cursor: "pointer",
            fontFamily: fontBody, transition: "all .15s",
            textTransform: "uppercase", letterSpacing: "0.04em",
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
          {!collapsed && "Sign Out"}
        </button>
      </div>

      {!collapsed && (
        <div style={{ padding: "8px 20px 12px" }}>
          <p style={{
            fontFamily: fontMono, fontSize: 10, color: muted,
            letterSpacing: "0.08em", lineHeight: 1.5, textTransform: "uppercase", margin: 0,
          }}>
            NYC Manufacturing<br />
            <span style={{ opacity: 0.6 }}>Since 2018 · DUMBO</span>
          </p>
        </div>
      )}
    </>
  );
}

export default function Sidebar({ section, setSection, mobileOpen, setMobileOpen, isMobile, store, setStore, userPermissions, badges, collapsed, setCollapsed }) {
  const handleNav = (key) => {
    setSection(key);
    setMobileOpen(false);
  };

  if (!isMobile) {
    return (
      <div style={{
        width: collapsed ? 64 : 260, height: "100vh", background: paper,
        borderRight: `2px solid ${ink}`, position: "fixed", top: 0, left: 0,
        zIndex: 50, overflow: "hidden", transition: "width .18s ease",
      }}>
        {/* Fixed-width inner wrapper: content lays out at its final width while the
            outer container animates and clips — prevents label reflow mid-transition */}
        <div style={{
          width: collapsed ? 64 : 260, height: "100%", flexShrink: 0,
          display: "flex", flexDirection: "column",
        }}>
          <NavList section={section} onNav={handleNav} store={store} setStore={setStore} userPermissions={userPermissions} badges={badges} collapsed={collapsed} onToggleCollapse={() => setCollapsed(!collapsed)} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div style={{
        position: "sticky", top: 0, zIndex: 80,
        background: paper, borderBottom: `2px solid ${ink}`,
        padding: "12px 16px 17px", display: "flex", alignItems: "center",
        justifyContent: "center",
      }}>
        <button onClick={() => setMobileOpen(true)} style={{
          background: paper, border: `2px solid ${ink}`, borderRadius: 0,
          padding: "7px 9px", cursor: "pointer", color: ink,
          display: "flex", alignItems: "center", position: "absolute", left: 16,
        }}>
          <HamburgerIcon />
        </button>
        <span style={{
          fontFamily: fontDisplay, fontSize: 18, fontWeight: 900,
          letterSpacing: "-0.02em", textTransform: "uppercase", color: ink,
        }}>
          NYC Manufacturing
        </span>
      </div>

      {mobileOpen && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 200 }}>
          <div onClick={() => setMobileOpen(false)} style={{
            position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(10,10,15,0.55)",
          }} />
          <div style={{
            position: "absolute", top: 0, left: 0, width: 280, height: "100%",
            background: paper, borderRight: `2px solid ${ink}`,
            display: "flex", flexDirection: "column", overflow: "hidden",
            boxShadow: `4px 0 0 ${ink}`,
          }}>
            <div style={{ padding: "12px 14px 0", textAlign: "right" }}>
              <button onClick={() => setMobileOpen(false)} style={{
                background: paper, border: `2px solid ${ink}`, borderRadius: 0,
                padding: "7px 9px", cursor: "pointer", color: ink,
                display: "inline-flex", alignItems: "center",
              }}>
                <CloseIcon />
              </button>
            </div>
            <NavList section={section} onNav={handleNav} store={store} setStore={setStore} userPermissions={userPermissions} badges={badges} />
          </div>
        </div>
      )}
    </>
  );
}
